import BlankView from '@/layouts/BlankView';

import homeRoutes from './home';
import schemeRoutes from './scheme';

// 路由配置
const routes = [
  {
    path: '/',
    name: '首页',
    redirect: '/home',
    component: BlankView,
    children: [
      // {
      //   path: 'home',
      //   name: '项目列表',
      //   component: () => import('@/pages/home/index')
      // },
      {
        path: 'pk',
        name: 'PK',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/pk/index')
      },
      {
        path: 'topo',
        name: 'Topo',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/topo/index')
      },
      {
        path: 'edit/:id',
        name: '新建平面图',
        meta: {
          params: {
            id: ''
          }
        },
        redirect: 'bench/:id'
      },
      // {
      //   path: 'projectDetail',
      //   name: '导出方案',
      //   meta: {},
      //   component: () => import('@/pages/projectDetail/index')
      // },
      {
        path: 'editProductList',
        name: '编辑清单',
        meta: {},
        redirect: to => {
          return {
            path: `/bench/${to.query.schemeId}`,
            query: {
              ...to.query,
              activeViewTab: 3
            }
          };
        }
        // component: () => import('@/pages/editProductList/index')
      },
      {
        path: 'productDetail',
        name: '产品详情',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/productDetail/index')
      },
      {
        path: 'productDetailSd',
        name: '产品详情',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/productDetail/detail.vue')
      },
      {
        path: 'productDetailCollection',
        name: '产品详情',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/productDetail/collection')
      },
      {
        path: 'productDetailMore',
        name: '产品详情',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/productDetail/moreProduct')
      },
      {
        path: 'estScheme',
        name: '网桥地勘方案',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/estScheme/index')
      },
      {
        path: 'systemView',
        name: '系统图',
        meta: {
          requireAuth: true
        },
        component: () => import('@/pagesV2/systemView/index')
      },
      {
        path: 'system2D',
        name: '2D系统图',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/systemView/2dIndex')
      },
      {
        path: 'system3D',
        name: '3D系统图',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/systemView/3dIndex')
      },
      {
        path: 'bench/:id',
        name: '工作台',
        meta: {
          params: {
            id: ''
          }
        },
        component: () => import('@/pagesV2/scheme/bench')
      },
      // {
      //   path: 'projectDetail',
      //   name: '导出清单',
      //   meta: {},
      //   component: () => import('@/pagesV2/projectDetail/index')
      // },
      // {
      //   path: 'projectDetailV2',
      //   redirect: 'projectDetail'
      // },
      {
        path: 'system2DV2',
        name: '2D系统图',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/systemView/2dIndex')
      },
      {
        path: 'system3DV2',
        name: '3D系统图',
        meta: {
          requireAuth: false
        },
        component: () => import('@/pagesV2/systemView/3dIndex')
      }
    ]
  },

  ...homeRoutes,
  ...schemeRoutes
];

export default routes;
